(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fliq-campaign-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fliq-hero')) {
    customElements.define('fliq-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.fh-slide')];
        this.dots = [...this.querySelectorAll('.fh-dot')];
        this.i = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
        this.ms = (parseInt(this.dataset.speed, 10) || 6) * 1000;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.auto = this.dataset.autoplay === 'true' && !reduce && this.slides.length > 1;
        this.dots.forEach((d, n) => d.addEventListener('click', () => { this.go(n); this.stop(); this.auto = false; }));
        if (this.auto) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => { if (this.auto) this.start(); });
          this.addEventListener('focusin', () => { this.stop(); this.auto = false; });
          this.start();
        }
        let x0 = null;
        this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) { this.go(this.i + (dx < 0 ? 1 : -1)); this.stop(); this.auto = false; }
          x0 = null;
        }, { passive: true });
        this.onSelect = (e) => {
          const n = this.slides.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (n > -1) { this.go(n); this.stop(); }
        };
        document.addEventListener('shopify:block:select', this.onSelect);
        this.go(this.i);
      }
      disconnectedCallback() { this.stop(); document.removeEventListener('shopify:block:select', this.onSelect); }
      start() { this.stop(); this.t = setInterval(() => this.go(this.i + 1), this.ms); }
      stop() { clearInterval(this.t); }
      go(n) {
        const len = this.slides.length;
        if (!len) return;
        this.i = (n + len) % len;
        this.slides.forEach((s, k) => {
          const on = k === this.i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          s.toggleAttribute('inert', !on);
        });
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.i ? 'true' : 'false'));
        this.style.setProperty('--fh-nav', this.slides[this.i].dataset.nav || '#ffffff');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fliq-featured-world"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var pause = function () { document.querySelectorAll('.fliq-world video').forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); v.setAttribute('controls', ''); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pause); else pause();
    document.addEventListener('shopify:section:load', pause);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
